import classNames from 'classnames';

import SubscriptionAvatar from '@/shared/subscriptionAvatar';
import { ImageUpload } from '@/ui/ImageUpload';

import type { AvatarUploadWrapperProps } from './AvatarUploadWrapper.types';

/**
 * Wrapper component that conditionally adds hover-to-upload functionality to an avatar.
 * When canUpload is false, renders a plain SubscriptionAvatar.
 * When canUpload is true, renders an ImageUpload with hover overlay for uploading.
 */
export function AvatarUploadWrapper({
  avatarUrl,
  onFileSelect,
  isUploading = false,
  canUpload = false,
  size = 32,
  className,
}: AvatarUploadWrapperProps) {
  // Non-interactive display for users who can't upload
  if (!canUpload || !onFileSelect) {
    return (
      <div className={classNames('rounded-full overflow-hidden', className)} style={{ width: size, height: size }}>
        <SubscriptionAvatar avatarUrl={avatarUrl} />
      </div>
    );
  }

  // Interactive with hover overlay for users who can upload
  return (
    <ImageUpload
      currentImageUrl={avatarUrl}
      onFileSelect={onFileSelect}
      shape="circle"
      size={size}
      isLoading={isUploading}
      className={className}
    />
  );
}
